import React, { Fragment } from 'react';

const About = () => {
  return (
    <Fragment>
      <br />
      <h4>This is a news briefing app.</h4>
      <h6>
        {' '}
        Version: <strong>1.0.0</strong>{' '}
      </h6>
      <p>&copy; Azhar Hasan 2020.</p>
    </Fragment>
  );
};

export default About;
